
import ApplicationsApi from '@/api/applicationApi'
const api = new ApplicationsApi()
import _ from 'lodash'
import Vue from 'vue'

export class ApplicationRowDraft {
  constructor(item, app) {
    this.headerId = item.headerId || app?.id
    this.rowId = item.rowId || item.id
    this.resourceId = item.resourceId || item.resource?.id || item.id
    this.resourceName = item.resource?.name || item.fullName || item.resourceName
    this.quantity = item.declaredQuantity || item.quantity
    this.unitId = item.unit?.id || item.measur?.id || item.measur
    this.supplyDate = item.declaredSupplyDate
    this.priorityId = item.declaredPriority?.id
    this.categoryId = item.categoryId || item.resource?.category?.code
    this.comment = item.description || item.comment || ''
    this.price = item.price
    this.urgentReason = item.urgentReason
  }

  difference(object) {
    let diff = _.transform(object, (result, value, key) => {
      if (value != this[key] ) {
        result[key] = value
        if ( key == 'unitId' ||  key == 'categoryId' ||  key == 'resourceName') {
          result.unitId = object.unitId || object.unit.id 
          result.categoryId =  object.categoryId
          result.resourceName = object.resourceName
          result.comment = object.comment 
        }
      }
    })
    if ( !Object.values(diff ).length ) {
      return
    }
    return {
      headerId: this.headerId,
      rowId: this.rowId,
      ...diff
    }
  }

  async editDraftResource( resourceName, measur, comment, categoryId, resourceId ) {
    let dif = this.difference({
      resourceName, unitId: +measur, comment, categoryId, resourceId 
    })
    if (dif) {
      if ( !dif.categoryId ) {
        dif.resourceId = resourceId
      }
      delete dif.headerId
      return await api.changeRowsInDraft({
        headerId: this.headerId,
        rows: [ dif ]
      })
    }
  }

  editDraft( item ) {
    let dif = this.difference(item)
    if (dif) {
      return {...dif, resourceId: this.resourceId}
      // return await api.changeRowsInDraft(dif)
    }
  }

  async addToApp() {
    return await api.addRowsToDraft({
      rows: [
        {
          resourceId: this.resourceId,
        }
      ],
      headerId: this.headerId
    })
  }

  async addNewToApp() {
    return await api.addRowsToDraft({
      rows: [
        {
          resourceName: this.resourceName,
          categoryId: this.categoryId,
          unitId: +this.unitId,
          comment: this.comment,
        }
      ],
      headerId: this.headerId
    })
  }


  static createdRow(resourceName, measur, comment, categoryId, app) {
    return new ApplicationRowDraft ({
      resourceName,
      measur,
      comment,
      categoryId
    }, app)
  }

  async deleteFromApp() {
    if ( this.rowId ) {
      return await api.deleteRows(this.headerId, [this.rowId])
        .catch(error => Vue.prototype.$log_error(error.message))
    }
  }
}